import './App.css';
import { ThemeProvider } from "styled-components";
import AnimatedCursor from "react-animated-cursor"
import Bubble from './components/Partical/Bubble';
import Main from './Main';
import 'bootstrap/dist/css/bootstrap.min.css';
import GlobalStyle from './components/styled/GlobalStyled';
import { themeMood } from './data';
import Draggable from 'react-draggable';



const CustomTheme = () => {
  return themeMood[0]
}
const theme = CustomTheme();
function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle theme={theme} />
      <Bubble color={theme.color} />
      <AnimatedCursor
        innerSize={8}
        outerSize={50}
        color={theme.cursor.color.first}
        outerAlpha={0.2}
        innerScale={0.7}
        outerScale={2}
      />
    
      <Main />

    </ThemeProvider>


  );
}

export default App;
